import apolloClient from 'api/apolloClient';
import {
  GET_CONFIGURABLE_EMAILS,
  GET_EMAILS_BY_PERIOD_ID,
  GET_EMAILS_BY_PERIOD_IDS,
  SAVE_CONFIGURABLE_EMAILS_FOR_USER,
} from 'api/queries/emailService';
import { ConfigurableEmailInfo, ConfigurableEmails, EmailMapping } from 'types/emailService';

export async function getEmailsByPeriodId(periodId: string): Promise<EmailMapping[]> {
  const result = await apolloClient.query<{ getEmailsByPeriodId: EmailMapping[] }>({
    query: GET_EMAILS_BY_PERIOD_ID,
    fetchPolicy: 'no-cache',
    variables: { periodId },
  });
  return result.data.getEmailsByPeriodId;
}

export async function getEmailsByPeriodIds(periodIds: string[]): Promise<EmailMapping[]> {
  const result = await apolloClient.query<{ getEmailsByPeriodIds: EmailMapping[] }>({
    query: GET_EMAILS_BY_PERIOD_IDS,
    fetchPolicy: 'no-cache',
    variables: { periodIds },
  });
  return result.data.getEmailsByPeriodIds;
}

export async function getConfigurableEmails(): Promise<ConfigurableEmails> {
  const res = await apolloClient.query<{
    getConfigurableEmails: ConfigurableEmailInfo[];
    getConfigurableEmailsForUser: string[];
  }>({
    query: GET_CONFIGURABLE_EMAILS,
    fetchPolicy: 'no-cache',
  });
  return {
    emails: res.data.getConfigurableEmails,
    emailsForUser: res.data.getConfigurableEmailsForUser,
  };
}

export async function saveConfigurableEmailsForUser(emailTypes: string[]): Promise<boolean> {
  const { data } = await apolloClient.mutate<{ saveConfigurableEmailsForUser: boolean }>({
    mutation: SAVE_CONFIGURABLE_EMAILS_FOR_USER,
    variables: { emailTypes },
  });
  return data?.saveConfigurableEmailsForUser || false;
}
